import { NgModule } from '@angular/core';
import { InfoTooltipComponent } from './info-tooltip.component';

@NgModule({
    imports: [InfoTooltipComponent],
    exports: [InfoTooltipComponent]
})
export class InfoTooltipModule {}
